import { PaymentModeEnum, PaymentStatusEnum } from "src/enums/order.enum";
import { CustomerOrder } from "src/interfaces/order.interface";
import { isChannelCustomerOrder } from "src/features/ActiveOrders/utils/channelOrder";

/** Aligns with backend `OrderService.captureCustomerOrderPayment`: non-channel, AUTHORIZED, AUTH mode. */
export function isEligibleForBatchCapture(order: CustomerOrder): boolean {
  return getBatchCaptureRowDisabledReason(order) == null;
}

/** When non-null, this order cannot be batch-captured (same rules as the backend). */
export function getBatchCaptureRowDisabledReason(order: CustomerOrder): string | null {
  if (!order.correlationId) {
    return "This row cannot be selected.";
  }
  if (isChannelCustomerOrder(order)) {
    return "External channel orders are not captured here.";
  }
  const pay = order.payment;
  if (!pay) {
    return "Only orders with Authorized card payments can be selected for bulk capture.";
  }
  const st = pay.paymentStatus ? String(pay.paymentStatus).toUpperCase() : "";
  if (st !== PaymentStatusEnum.AUTHORIZED) {
    return "Only authorized payments can be captured. Use Pay or order details for other statuses.";
  }
  const mode = pay.paymentMode != null ? String(pay.paymentMode).toUpperCase() : "";
  if (mode !== PaymentModeEnum.AUTH) {
    return "Only authorize-then-capture (AUTH) payments can be batch-captured. Sale-mode charges are already settled.";
  }
  return null;
}
